import { Add, PlusOne, TableRestaurant } from "@mui/icons-material";
import { TabContext, TabPanel } from "@mui/lab";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Input,
    InputLabel,
    MenuItem,
    Select,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppContext";
import CreateResourceModal from "../../../components/CreateResourceModal";
import LogoutButton from "../../../components/LogoutButton";
import { PosContext } from "../../../shared/PosContext";
import { useStyles } from "./styles";
import { useCreateTable } from "../../../shared/hooks/useTablesData";
import { isRoleAdmin } from "../../../frappeConfig";

const SettingsDialog = ({ open = true, setOpen, handleClose }) => {
    const classes = useStyles();

    const { tablesMovingContext, userInfo } = useContext(AppContext);

    const { floors, floorContext, floorRooms, roomContext, refetchTablesData } =
        useContext(PosContext);

    const [selectedTab, setSelectedTab] = useState("0");

    const [selectedFloor, setSelectedFloor] = floorContext;
    const [selectedRoom, setSelectedRoom] = roomContext;
    const [moving, setMoving] = tablesMovingContext;

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }

        if (setOpen) {
            setOpen(false);
        }
    };

    const handleFloorChange = (e, floor) => {
        setSelectedFloor(floor.props.value);
    };

    const handleRoomChange = (e, room) => {
        setSelectedRoom(room.props.value);
    };

    const [newTableOpen, setNewTableOpen] = useState(false);
    const toggleNewTable = () => setNewTableOpen(false);
    const handleAddTable = () => {
        setNewTableOpen(true);
    };

    return (
        <React.Fragment>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>
                    <div className={classes.DialogHeader}>
                        <span>POS Configrations</span>
                        <span style={{ color: "#e14954" }}>
                            {userInfo.full_name}
                        </span>
                    </div>
                </DialogTitle>
                <DialogContent className={classes.SettingsDialog}>
                    <TabContext value={selectedTab}>
                        <div className={classes.SettingsTabsContainer}>
                            <div className={classes.SettingsTabs}>
                                <Tabs
                                    aria-label="Vertical tabs"
                                    orientation="vertical"
                                    sx={{ minWidth: 100, height: 160 }}
                                    value={selectedTab}
                                    onChange={(event, newVal) =>
                                        setSelectedTab(newVal)
                                    }
                                >
                                    <Tab
                                        value={"0"}
                                        label="User Settings"
                                    ></Tab>
                                    {isRoleAdmin(
                                        userInfo.role_profile_name
                                    ) && (
                                        <Tab
                                            value={"2"}
                                            label="Layout Settings"
                                        ></Tab>
                                    )}
                                </Tabs>
                            </div>
                            <div className={classes.SettingsContent}>
                                <TabPanel sx={{ paddingTop: 0 }} value={"0"}>
                                    {isRoleAdmin(
                                        userInfo.role_profile_name
                                    ) && (
                                        <Accordion defaultExpanded={true}>
                                            <AccordionSummary
                                                expandIcon={
                                                    <GridExpandMoreIcon />
                                                }
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Typography>
                                                    Floor Settings
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div
                                                    className={
                                                        classes.FloorSettings
                                                    }
                                                >
                                                    <FormControl
                                                        className="FloorSelect"
                                                        variant="standard"
                                                    >
                                                        <InputLabel id="floors-select">
                                                            Floors
                                                        </InputLabel>
                                                        <Select
                                                            labelId="floors-select-standard-label"
                                                            value={
                                                                selectedFloor
                                                            }
                                                            onChange={
                                                                handleFloorChange
                                                            }
                                                            label={"Floor"}
                                                        >
                                                            {floors &&
                                                                Object.values(
                                                                    floors
                                                                ).map(
                                                                    (
                                                                        floor,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            floor.description !==
                                                                            "takeaway"
                                                                        ) {
                                                                            return (
                                                                                <MenuItem
                                                                                    key={
                                                                                        "Floor_Item_" +
                                                                                        index
                                                                                    }
                                                                                    value={
                                                                                        floor
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        floor.description
                                                                                    }
                                                                                </MenuItem>
                                                                            );
                                                                        }
                                                                    }
                                                                )}
                                                        </Select>
                                                    </FormControl>

                                                    {floorRooms ? (
                                                        <FormControl variant="standard">
                                                            <InputLabel id="rooms-select">
                                                                Room
                                                            </InputLabel>
                                                            <Select
                                                                labelId="rooms-select-standard-label"
                                                                value={
                                                                    selectedRoom
                                                                }
                                                                onChange={
                                                                    handleRoomChange
                                                                }
                                                                label={"Room"}
                                                            >
                                                                {Object.keys(
                                                                    floorRooms
                                                                ).map(
                                                                    (
                                                                        room,
                                                                        index
                                                                    ) => (
                                                                        <MenuItem
                                                                            value={
                                                                                floorRooms[
                                                                                    room
                                                                                ]
                                                                            }
                                                                            key={
                                                                                "Room_Item_" +
                                                                                index
                                                                            }
                                                                        >
                                                                            {
                                                                                room
                                                                            }
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    ) : (
                                                        <FormControl
                                                            style={{
                                                                justifyContent:
                                                                    "center",
                                                            }}
                                                            variant="standard"
                                                        >
                                                            <Typography>
                                                                No Rooms
                                                                Available.
                                                            </Typography>
                                                        </FormControl>
                                                    )}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    )}
                                    <LogoutButton />
                                </TabPanel>
                                <TabPanel value={"2"}>
                                    <div className={classes.LayoutButtons}>
                                        <Button
                                            className={classes.MoveTablesButton}
                                            onClick={() => {
                                                setMoving(true);
                                                setOpen(false);
                                            }}
                                        >
                                            <TableRestaurant
                                                style={{
                                                    marginRight: "0.5rem",
                                                }}
                                            />
                                            Move Tables
                                        </Button>
                                        <Button
                                            className={classes.MoveTablesButton}
                                            onClick={handleAddTable}
                                        >
                                            <Add
                                                style={{
                                                    marginRight: "0.5rem",
                                                }}
                                            />
                                            Add New Tables
                                        </Button>
                                    </div>
                                    <CreateResourceModal
                                        model={selectedRoom}
                                        doctype="Restaurant Object"
                                        fieldname="floor_plan"
                                        docname={selectedRoom?.name}
                                        room={selectedRoom}
                                    />
                                </TabPanel>
                            </div>
                        </div>
                    </TabContext>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <NewTableDialog
                open={newTableOpen}
                onClose={toggleNewTable}
                selectedRoom={selectedRoom}
                onAdd={() => {
                    setOpen(false);
                    setMoving(true);
                }}
            />
        </React.Fragment>
    );
};

const NewTableDialog = ({ open, onClose, selectedRoom, onAdd }) => {
    const { refetchTablesData } = useContext(PosContext);
    const createTableMutation = useCreateTable();
    const [tableDesc, setTableDesc] = useState("");

    const handleAdd = () => {
        createTableMutation.mutate(
            {
                tableFormData: {
                    room: selectedRoom.name,
                    description: tableDesc,
                },
            },
            {
                onSuccess: () => {
                    refetchTablesData();
                    onClose();
                    onAdd();
                },
                onError: (err) => {
                    console.log(err);
                },
            }
        );
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Table Name</DialogTitle>
            <DialogContent>
                <Input onChange={(e) => setTableDesc(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAdd}>Add</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SettingsDialog;
